<!-- Общая адаптивная группа действий в заголовке подробностей. -->
<template>
  <div class="record-list-actions" role="group" :aria-label="label"><slot /></div>
</template>
<script>
export default {
  name: "RecordListActions",
  props: { label: { type: String, default: "Действия с записью" } },
};
</script>
<style scoped>
.record-list-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: auto;
}
@container record-list-details (max-width: 680px) {
  .record-list-actions {
    flex-wrap: wrap;
    width: 100%;
    margin-left: 0;
    gap: 10px;
  }

  /* Действие с диалогом имеет несколько корней: slot-scope не доходит до
     вложенного BaseButton. Размер задаём фактическим кнопкам группы. */
  .record-list-actions > :deep(button) {
    flex: 1 1 calc(50% - 5px);
    min-width: 0;
    min-height: 44px;
    height: auto;
    white-space: normal;
    line-height: 1.3;
  }
}
</style>
